// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1_TiM","description":"PatientConsentPreview_description__166FH"};